export { PLUGIN_KEY, PLUGIN_PRIORITY, TrimRows } from "./trimRows.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/trimRows/index.mjs
// module id = 1554
// module chunks = 1